// ---------------------------------------------------------------------------
// Google Ads conversion tracking helper
// Base tag (AW-17895994697) is loaded in public/index.html.
//
// TO ENABLE CONVERSIONS: once you create the conversion actions in Google Ads,
// paste the conversion LABEL for each below (the part after the "/" in
// "AW-17895994697/AbC-D_efG..."). Leaving a label blank simply does nothing.
// ---------------------------------------------------------------------------

const ADS_ID = "AW-17895994697";

// Fill these in from Google Ads → Conversions → (your action) → Tag setup.
export const CONVERSIONS = {
  lead: "9KazCNeokPYcEMnqvNVC",   // form submission (fires on /thank-you)
  call: "SGHlCJbOhvYcEMnqvNVC",   // phone call click
};

// Generic gtag event passthrough (safe if gtag isn't loaded yet).
export function gtagEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

// Fire a Google Ads conversion for a given type ("lead" | "call").
// No-op until the matching label is filled in above.
export function reportConversion(type, params = {}) {
  const label = CONVERSIONS[type];
  if (!label) return;
  gtagEvent("conversion", { send_to: `${ADS_ID}/${label}`, ...params });
}
